import api from '@/api'

class Options {
  getOptionsNegara () {
    return new Promise((resolve, reject) => {
      api.get('/v1/negara')
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          if (e.response.status === 429) {
            this.flash('Mohon maaf server tidak dapat merespon dengan baik', 'error', {timeout: 3000})
          }
          // FIXME: Tell our user when we got some errors
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsProvinsi () {
    return new Promise((resolve, reject) => {
      api.get('/v1/provinsi_2018')
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          if (e.response.status === 429) {
            this.flash('Mohon maaf server tidak dapat merespon dengan baik', 'error', {timeout: 3000})
          }
          // FIXME: Tell our user when we got some errors
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsKabupaten (kodeProvinsi) {
    return new Promise((resolve, reject) => {
      api.get('/v2/kabupaten_2018_by_provinsi/' + kodeProvinsi)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          if (e.response.status === 429) {
            this.flash('Mohon maaf server tidak dapat merespon dengan baik', 'error', {timeout: 3000})
          }
          // FIXME: Tell our user when we got some errors
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsAgama () {
    return new Promise((resolve, reject) => {
      api.get('/v1/agama')
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          if (e.response.status === 429) {
            this.flash('Mohon maaf server tidak dapat merespon dengan baik', 'error', {timeout: 3000})
          }
          // FIXME: Tell our user when we got some errors
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsJenjang () {
    return new Promise((resolve, reject) => {
      api.get('/v1/jenjang')
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          if (e.response.status === 429) {
            this.flash('Mohon maaf server tidak dapat merespon dengan baik', 'error', {timeout: 3000})
          }
          // FIXME: Tell our user when we got some errors
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsPekerjaan () {
    return new Promise((resolve, reject) => {
      api.get('/v1/pekerjaan_orang_tua')
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          if (e.response.status === 429) {
            this.flash('Mohon maaf server tidak dapat merespon dengan baik', 'error', {timeout: 3000})
          }
          // FIXME: Tell our user when we got some errors
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsStatus () {
    return new Promise((resolve, reject) => {
      api.get('/v1/status_org_tua')
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          if (e.response.status === 429) {
            this.flash('Mohon maaf server tidak dapat merespon dengan baik', 'error', {timeout: 3000})
          }
          // FIXME: Tell our user when we got some errors
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsKesehatan () {
    return new Promise((resolve, reject) => {
      api.get('/v1/kesehatan')
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          if (e.response.status === 429) {
            this.flash('Mohon maaf server tidak dapat merespon dengan baik', 'error', {timeout: 3000})
          }
          // FIXME: Tell our user when we got some errors
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsLokasiUjian (kodePenawaran, isDisable) {
    let endpoint = `/v2/jadwal_ujian_by_kode_penawaran/${kodePenawaran}`
    if (isDisable) {
      endpoint = `/v2/jadwal_ujian_disability_by_kode_penawaran/${kodePenawaran}`
    }
    return new Promise((resolve, reject) => {
      api.get(endpoint)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          if (e.response.status === 429) {
            this.flash('Mohon maaf server tidak dapat merespon dengan baik', 'error', {timeout: 3000})
          }
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsPendidikan () {
    return new Promise((resolve, reject) => {
      api.get('/v1/riwayat_pendidikan_s2')
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          if (e.response.status === 429) {
            this.flash('Mohon maaf server tidak dapat merespon dengan baik', 'error', {timeout: 3000})
          }
          // FIXME: Tell our user when we got some errors
          console.log(e)
        })
    })
  }

  getOptionsJalur () {
    return new Promise((resolve, reject) => {
      api.get('/v1/jalur')
        .then(response => {
          resolve(response.data.data)
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          alert('error , please tell the developer')
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsKodeBayar () {
    return new Promise((resolve, reject) => {
      api.get('/v1/kode_pembayaran')
        .then(response => {
          resolve(response.data.data)
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          alert('error , please tell the developer')
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsPenawaran () {
    return new Promise((resolve, reject) => {
      api.get('/v1/penawaran_jalur')
        .then(response => {
          resolve(response.data.data)
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          alert('error , please tell the developer')
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsProdi () {
    return new Promise((resolve, reject) => {
      api.get('/v2/program_studi_minat/' + this.minat)
        .then(response => {
          resolve(response.data.data)
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          alert('error , please tell the developer')
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsMinat () {
    return new Promise((resolve, reject) => {
      api.get('/v1/minat')
        .then(response => {
          resolve(response.data.data)
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          alert('error , please tell the developer')
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsKelasJalur () {
    return new Promise((resolve, reject) => {
      api.get('/v2/kelas_jalur/' + this.penawaranJalur)
        .then(response => {
          resolve(response.data.data)
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          alert('error , please tell the developer')
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsRuang (idGedung) {
    return new Promise((resolve, reject) => {
      api.get('/v2/ruang/' + idGedung)
        .then(response => {
          resolve(response.data.data)
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsGedung () {
    return new Promise((resolve, reject) => {
      api.get('/v1/gedung')
        .then(response => {
          resolve(response.data.data)
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsJenisSekolah () {
    return new Promise((resolve, reject) => {
      api.get('/v1/jenis_sekolah')
        .then(response => {
          resolve(response.data.data)
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          alert('error , please tell the developer')
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsJurusanSekolah () {
    return new Promise((resolve, reject) => {
      api.get('/v1/jurusan_sekolah')
        .then(response => {
          resolve(response.data.data)
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          alert('error , please tell the developer')
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsJenjangSma () {
    return new Promise((resolve, reject) => {
      api.get('/v1/jenjang_sma')
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          if (e.response.status === 429) {
            this.flash('Mohon maaf server tidak dapat merespon dengan baik', 'error', {timeout: 3000})
          }
          // FIXME: Tell our user when we got some errors
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsJenjangProdi () {
    return new Promise((resolve, reject) => {
      api.get('/v1/jenjang_prodi')
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          if (e.response.status === 429) {
            this.flash('Mohon maaf server tidak dapat merespon dengan baik', 'error', {timeout: 3000})
          }
          // FIXME: Tell our user when we got some errors
          console.log(e)
          reject(e)
        })
    })
  }

  getOptionsFakultasJenjang (idJenjang) {
    return new Promise((resolve, reject) => {
      api.get(`/v1/public/fakultas/jenjang/${idJenjang}`)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          reject(e.response)
        })
    })
  }

  getOptionsPenawaranJalurProdi (idProdi) {
    return new Promise((resolve, reject) => {
      api.get(`/v2/public/penawaran_jalur/prodi/${idProdi}`)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          reject(e.response)
        })
    })
  }
}

export default new Options()



// WEBPACK FOOTER //
// ./src/helper/options.js